import { FacebookIcon, facebookHaPlugin, facebookName } from '@unipile/provider-facebook-ui';
import { GoogleIcon, googleHaPlugin, googleName } from '@unipile/provider-google-ui';
import { ImapIcon, ImapHaPlugin, imapName } from '@unipile/provider-imap-ui';
import { instagramHaPlugin, InstagramIcon, instagramName } from '@unipile/provider-instagram-ui';
import { LinkedinIcon, linkedinHaPlugin, linkedinName } from '@unipile/provider-linkedin-ui';
import { MockProviderIcon, mockName, mockProviderHaPlugin } from '@unipile/provider-mock-ui';
import { OutlookIcon, outlookHaPlugin, outlookName } from '@unipile/provider-outlook-ui';
import { telegramHaPlugin, TelegramIcon, telegramName } from '@unipile/provider-telegram-ui';
import { WhatsappIcon, whatsappHaPlugin, whatsappName } from '@unipile/provider-whatsapp-ui';
import { Provider } from '@unipile/types';
import { type HostedAuthPlugin } from '@unipile/ui';

export const MessagingProvidersList: Provider[] = ['linkedin', 'whatsapp', 'mock', 'telegram', 'instagram', 'facebook'];

export const MailingProvidersList: Provider[] = ['google', 'outlook', 'imap'];

/**
 * @todo
 * Dynamicly build records based on available packages
 */

export const ProviderPlugins: Record<Provider, HostedAuthPlugin> = {
  facebook: facebookHaPlugin,
  linkedin: linkedinHaPlugin,
  mock: mockProviderHaPlugin,
  google: googleHaPlugin,
  outlook: outlookHaPlugin,
  whatsapp: whatsappHaPlugin,
  imap: ImapHaPlugin,
  telegram: telegramHaPlugin,
  instagram: instagramHaPlugin,
};

export const ProviderIcons: Record<Provider, string> = {
  facebook: FacebookIcon,
  linkedin: LinkedinIcon,
  mock: MockProviderIcon,
  google: GoogleIcon,
  outlook: OutlookIcon,
  imap: ImapIcon,
  whatsapp: WhatsappIcon,
  telegram: TelegramIcon,
  instagram: InstagramIcon,
};

export const ProviderNames: Record<Provider, string> = {
  facebook: facebookName,
  linkedin: linkedinName,
  mock: mockName,
  google: googleName,
  outlook: outlookName,
  imap: imapName,
  whatsapp: whatsappName,
  telegram: telegramName,
  instagram: instagramName,
};
